import React from "react";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const styles = {
  headerCell: {
    fontWeight: "semibold",
    backgroundColor: "#fff",
    fontSize: 16,
    position: "sticky",
    top: 0,
    zIndex: 1200,
    padding: '6px',
  },
  columnHeaderCell: {
    fontWeight: "semibold",
    backgroundColor: "#fff",
    position: "sticky",
    top: 0,
    zIndex: 1200,
    fontSize: 16,
    width: 170,
    padding: '6px',
  },
};

export default function FieldsTableHead({ displayReceivingSettings = true }) {
  return (
    <TableHead>
      <TableRow>
        <TableCell sx={styles.headerCell}></TableCell>
        <TableCell sx={styles.columnHeaderCell}>Inventory Display</TableCell>
        {displayReceivingSettings && (
          <TableCell sx={styles.columnHeaderCell}>Receiving Only</TableCell>
        )}
      </TableRow>
    </TableHead>
  );
}
